// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageslider {
  display: flex;
  margin-left: 186px; /* Space for admin navbar */
}

.upload-image-from {
  width: 440px; /* Set width for upload form */
  margin-right: 20px; /* Add margin between sections */
  padding: 20px;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Shadow effect */
  animation: fadeInLeft 0.5s ease-in-out; /* Animation effect */
}

.show-image-div {
  flex-grow: 1; /* Allow image list to grow */
  border-radius: 10px;
  margin-top: 20px; /* Add margin to separate from form */
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Shadow effect */
  animation: fadeInRight 0.5s ease-in-out; /* Animation effect */
}

.imageslider-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.imageslider-input,
.imageslider-textarea,
.imageslider-file-input-label,
.imageslider-button {
  width: 100%;
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.imageslider-button {
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.imageslider-button:hover {
  background-color: #0056b3;
}

.imageslider-file-input-label {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.imageslider-image {
  position: relative;
  margin-bottom: 20px;
}

.slideimage-upload {
  width: 100%;
  max-width: 200px; /* Limit the width of the image */
  height: auto; /* Maintain aspect ratio */
  border-radius: 5px;
}

.Delete-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #dc3545;
  color: #fff;
  border: none;
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.Delete-button:hover {
  background-color: #c82333;
}

@media screen and (max-width: 768px) {
  .imageslider {
    flex-direction: column; /* Change to column layout on smaller screens */
    margin-left: 0; /* No left margin on smaller screens */
  }

  .upload-image-from,
  .show-image-div {
    width: calc(100% - 20px); /* Adjust width for mobile */
    margin-right: 0; /* Remove margin on smaller screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Admin/sliderimageupload/SliderImage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB,EAAE,2BAA2B;AACjD;;AAEA;EACE,YAAY,EAAE,8BAA8B;EAC5C,kBAAkB,EAAE,gCAAgC;EACpD,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC,EAAE,kBAAkB;EAC3D,sCAAsC,EAAE,qBAAqB;AAC/D;;AAEA;EACE,YAAY,EAAE,6BAA6B;EAC3C,mBAAmB;EACnB,gBAAgB,EAAE,qCAAqC;EACvD,aAAa;EACb,sBAAsB;EACtB,uCAAuC,EAAE,kBAAkB;EAC3D,uCAAuC,EAAE,qBAAqB;AAChE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,iCAAiC;EACnD,YAAY,EAAE,0BAA0B;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB,EAAE,+CAA+C;IACvE,cAAc,EAAE,sCAAsC;EACxD;;EAEA;;IAEE,wBAAwB,EAAE,4BAA4B;IACtD,eAAe,EAAE,qCAAqC;EACxD;AACF","sourcesContent":[".imageslider {\n  display: flex;\n  margin-left: 186px; /* Space for admin navbar */\n}\n\n.upload-image-from {\n  width: 440px; /* Set width for upload form */\n  margin-right: 20px; /* Add margin between sections */\n  padding: 20px;\n  margin-top: 20px;\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Shadow effect */\n  animation: fadeInLeft 0.5s ease-in-out; /* Animation effect */\n}\n\n.show-image-div {\n  flex-grow: 1; /* Allow image list to grow */\n  border-radius: 10px;\n  margin-top: 20px; /* Add margin to separate from form */\n  padding: 20px;\n  background-color: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Shadow effect */\n  animation: fadeInRight 0.5s ease-in-out; /* Animation effect */\n}\n\n.imageslider-form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.imageslider-input,\n.imageslider-textarea,\n.imageslider-file-input-label,\n.imageslider-button {\n  width: 100%;\n  margin-bottom: 15px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.imageslider-button {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.imageslider-button:hover {\n  background-color: #0056b3;\n}\n\n.imageslider-file-input-label {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.imageslider-image {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.slideimage-upload {\n  width: 100%;\n  max-width: 200px; /* Limit the width of the image */\n  height: auto; /* Maintain aspect ratio */\n  border-radius: 5px;\n}\n\n.Delete-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: #dc3545;\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  padding: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.Delete-button:hover {\n  background-color: #c82333;\n}\n\n@media screen and (max-width: 768px) {\n  .imageslider {\n    flex-direction: column; /* Change to column layout on smaller screens */\n    margin-left: 0; /* No left margin on smaller screens */\n  }\n\n  .upload-image-from,\n  .show-image-div {\n    width: calc(100% - 20px); /* Adjust width for mobile */\n    margin-right: 0; /* Remove margin on smaller screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
